module.exports = __webpack_public_path__ + "static/media/BannerLibrary.8a980123.jpg";